<template>
    <div class="carReport">
        <el-button type="primary" @click="createPdf">下载报告</el-button>
        <!-- <el-button type="primary" @click="createTable" v-if="!isNoCreateReport">下载报告</el-button> -->
        <div class="dingmei">
            <div class="tops" id="top">
                <div class="top">
                    <div class="l">
                        <span class="l-t">天信公估</span>
                        <span class="l-b">TIANXIN  ADJUSTERS</span>
                    </div>
                    <div class="r">
                        报告编号：
                        <span class="r-r">{{detail.assets.caseNo}}号</span>
                    </div>
                </div>
            </div>
        </div>
        
        
        
        <div id="pdfdom" class="pdf">
            <div class="pdf-content1" id="pdf-content1" :style="'height:'+height1" ref="content1">
                <div class="title">广州天信保险公估有限公司</div>
                <div class="name">车辆损失评估报告书</div>
                <div class="info">
                    <div class="item">
                        <div class="label">案件名称：</div>
                        <div class="value">{{detail.assets.caseName}}损失评估报告</div>
                    </div>
                    <div class="item">
                        <div class="label">委托项目：</div>
                        <div class="value">{{detail.assets.entrustedProject}}损失评估</div>
                    </div>
                    <div class="item">
                        <div class="label">委 托 方：</div>
                        <div class="value">{{detail.carDamage.clientName}}</div>
                    </div>
                    <div class="item">
                        <div class="label">评估日期：</div>
                        <div class="value">{{nowDate}}</div>
                    </div>
                </div>




                <div class="name2">车辆损失报告</div>
                <div class="tip">致:{{detail.carDamage.clientName}}</div>
                <div class="name3">{{detail.carDamage.licenseNo}}损失评估报告书</div>



                <div class="content">
                    <div class="item">
                        <div class="item-t">一、引言</div>
                        <div class="item-c">{{detail.carDamage.introduction}}</div>
                    </div>
                    <div class="item">
                        <div class="item-t">二、注册评估师声明</div>
                        <div class="item-c">{{detail.carDamage.statAppra}}</div>
                    </div>
                    <div class="item">
                        <div class="item-t">三、委托方</div>
                        <div class="item-c">{{detail.carDamage.clientName}}</div>
                    </div>
                    <div class="item">
                        <div class="item-t">四、评估目的</div>
                        <div class="item-c">{{detail.carDamage.evaluaPurpose}}</div>
                    </div>
                    <div class="item">
                        <div class="item-t">五、评估基准日</div>
                        <div class="item-c">{{detail.carDamage.appraisalDate}}</div>
                    </div>
                    <div class="item">
                        <div class="item-t">六、评估对象</div>
                        <div class="item-c">{{detail.carDamage.pgdx}}</div>
                    </div>
                    <div class="item">
                        <div class="item-t">七、评估原则</div>
                        <div class="item-c">{{detail.carDamage.evaluationPrin}}</div>
                    </div>
                    <div class="item">
                        <div class="item-t">
                            八、保险责任认定及依据
                        </div>
                        <div class="item-c">{{detail.carDamage.bxzrdyj}}</div>
                    </div>
                    <div class="item">
                        <div class="item-t">九、价格评估依据</div>
                        <div class="item-c">{{detail.carDamage.jgpgyj}}</div>
                    </div>
                    <div class="item">
                        <div class="item-t">十、价格评估方法</div>
                        <div class="item-c">成本法。</div>
                    </div>
                    <div class="item">
                        <div class="item-t">十一、损失核定</div>
                        <div class="item-c">{{detail.carDamage.sshd}}</div>
                    </div>
                    <div class="item">
                        <div class="item-t">十二、公估依据</div>
                        <div class="item-c">{{detail.carDamage.ggyj}}</div>
                    </div>
                    <div class="item">
                        <div class="item-t">十三、评估报告法律效应力</div>
                        <div class="item-c">{{detail.carDamage.pgbgflxl}}</div>
                    </div>
                </div>

                <div class="signature">
                    <div class="item">责 任 公 估 师（签字）：<span></span> </div>
                    <div class="item">审    核    人（签字）：<span></span> </div>
                </div>
                <div class="company">
                    <div class="item">广州天信保险公估有限公司</div>
                    <div class="item">{{zhDate}}</div>
                </div>
            </div>
            


            <div class="imgs" id="content2">
                <div class="img">
                    <div class="img-t">资质资料：</div>
                    <div class="imglist">
                        <div class="imgitem" v-for="(item,index) in assetsNalMap1" :key='index'>
                            <img
                            class="image"
                            :src="item+'?'+new Date().getTime()"
                            crossorigin="anonymous"
                            />
                        </div>
                    </div>
                    
                </div>

                <div class="img">
                    <div class="img-t">公估师：</div>
                    <div class="imglist">
                        <div class="imgitem" v-for="(item,index) in assetsNalMap2" :key='index'>
                            <img
                            class="image"
                            :src="item+'?'+new Date().getTime()"
                            crossorigin="anonymous"
                            />
                        </div>
                    </div>
                </div>


                <div class="img">
                    <div class="img-t">车辆损失清单：</div>
                    <div class="table" id="table">
                        <div class="header">
                            <img src="../../../assets/images/icon09.png" alt="">
                        </div>
                        <div class="t-title">
                            机动车辆损失明细单
                        </div>
                        <div class="tr">
                            <div class="td1">车主</div>
                            <div class="td2">{{detail.carDamage.owner}}</div>
                            <div class="td1">车牌号</div>
                            <div class="td1">{{detail.carDamage.licenseNo}}</div>
                            <div class="td1">厂牌型号</div>
                            <div class="td3">{{detail.carDamage.brand}}</div>
                        </div>
                        <div class="tr">
                            <div class="td1">VIN码</div>
                            <div class="td2">{{detail.carDamage.vehicleNo}}</div>
                            <div class="td2">发动机号</div>
                            <div class="td4">{{detail.carDamage.engineNo}}</div>
                        </div>
                        <div class="tr">
                            <div class="td1">序号</div>
                            <div class="td2">更换配件项目</div>
                            <div class="td1">数量</div>
                            <div class="td1">评估价格</div>
                            <div class="td1">维修项目</div>
                            <div class="td2">内容</div>
                            <div class="td1">评估价格</div>
                        </div>
                        <div class="contentall">
                            <div class="content1">
                                <div class="tr" v-for="(item,index) in lossList1" :key="index">
                                    <div class="td1">{{index+1}}</div>
                                    <div class="td2">{{item.project}}</div>
                                    <div class="td1">{{item.number}}</div>
                                    <div class="td1 td1noborder">{{item.price}}</div>
                                </div>
                                <div class="tr" v-for="(item,index) in zeroList1" :key="index">
                                    <div class="td1">{{index+1}}</div>
                                    <div :class="(zeroList1.length-1)==index?'td2 td1noborder':'td2 tdzero'"></div>
                                    <div :class="(zeroList1.length-1)==index?'td1 td1noborder':'td1 tdzero'"></div>
                                    <div :class="(zeroList1.length-1)==index?'td1 td1noborder':'td1 tdzero'"></div>
                                </div>
                                
                            </div>
                            <div class="content2">
                                <div class="tr" v-for="(item,index) in lossList2" :key="index">
                                    <div class="td1">{{item.project}}</div>
                                    <div class="td2">{{item.content}}</div>
                                    <div class="td1 td1noborder">{{item.price}}</div>
                                </div>
                                 <div class="tr" v-for="(item,index) in zeroList2" :key="index">
                                    <div :class="(zeroList2.length-1)==index?'td1 td1noborder':'td1 tdzero'"></div>
                                    <div :class="(zeroList2.length-1)==index?'td2 td1noborder':'td2 tdzero'"></div>
                                    <div :class="(zeroList2.length-1)==index?'td1 td1noborder':'td1 tdzero'"></div>
                                </div>
                            </div>
                        </div>
                        <div class="tr">
                            <div class="td5">材料费小计：{{price1}}元</div>
                            <div class="td4">工时费小计: {{price2}}元</div>
                        </div>
                        <div class="tr">
                            <div class="td9">总计金额：{{totalPrice}} ({{price1+price2}}元)</div>
                        </div>
                    </div>
                </div>
                <div class="img">
                    <div class="img-t">委托书：</div>
                    <div class="imglist">
                        <div class="imgitem" v-for="(item,index) in assetsNalMap3" :key='index'>
                            <img
                            class="image"
                            :src="item+'?'+new Date().getTime()"
                            crossorigin="anonymous"
                            />
                        </div>
                    </div>
                </div>
                
                <div class="img">
                    <div class="img-t">相关证件、单据：</div>
                    <div class="imglist">
                        <div class="imgitem" v-for="(item,index) in assetsNalMap4" :key='index'>
                            <img
                            class="image"
                            :src="item+'?'+new Date().getTime()"
                            crossorigin="anonymous"
                            />
                        </div>
                    </div>
                </div>

                <div class="img">
                    <div class="img-t">车辆损失相片：</div>
                    <div class="imglist imglist2">
                        <div class="imgitem" v-for="(item,index) in assetsNalMap5" :key='index'>
                            <img
                            class="image"
                            :src="item+'?'+new Date().getTime()"
                            crossorigin="anonymous"
                            />
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="pages">
        </div>
        <div class="dingmeiimg"></div>

        <div class="backtop" @click="backTop()">
            <i class="el-icon-top"></i>
        </div>
    </div>
</template>
<script>
import api from '../../../api/main'
import html2Canvas from 'html2canvas'
import store from '../../../store'
import {convertCurrency} from '../../../utils/index'
// import { provinceAndCityData , CodeToText } from "element-china-area-data";

export default {
    name: 'carReport',
    components:{
        
    },
   
    data () {
        return {
            page:1,
            htmlTitle:'车损评估报告模板',
            detail:{
                lossList:[],
            },
            assetsMaps1:[],
            assetsMaps2:[],
            assetsNalMap1:[],
            assetsNalMap2:[],
            assetsNalMap3:[],
            assetsNalMap4:[],
            assetsNalMap5:[],

            lossList1:[],
            lossList2:[],
            price1:0,
            price2:0,
            totalPrice:'',
            zeroList1:[],
            zeroList2:[],
            zhDate:'',
            height1:'',
            scale:1,
            isNoCreateReport:false,
            nowDate:'',
        }
    },
    created(){
        this.queryAssetsMaterialDamage();
    },
    mounted(){
        this.isNoCreateReport = this.$route.query.isNoCreateReport;
    },
    methods:{
        getDateYMD(){
            let d = new Date();
            let year = d.getFullYear() > 9 ? d.getFullYear() : '0' + d.getFullYear();
            let month = (d.getMonth()+1) > 9 ? d.getMonth()+1 : '0' + (d.getMonth()+1);
            let day = d.getDate() > 9 ? d.getDate() : '0' + d.getDate();
            return year + '-' + month + '-' + day
        },
        async createPdf(imgStr){
            // return;
            //  imgStr = imgStr.slice(22);
            let CarInfo = [];
            let length = this.lossList1.length>this.lossList2.length?this.lossList1.length:this.lossList2.length;
            for(let i = 0;i<length;i++){
                CarInfo.push({
                    "Order":JSON.stringify(parseInt(i)+1) ,
                    "Parts": "",
                    "Number": 0,
                    "PartsEvaluation": 0,
                    "TepairItems": "",
                    "Content": "",
                    "Evaluation": 0
                })
                if(this.lossList1[i]){
                    CarInfo[i].Parts = this.lossList1[i].project,
                    CarInfo[i].Number = this.lossList1[i].number;
                    CarInfo[i].PartsEvaluation = this.lossList1[i].price;
                }
                if(this.lossList2[i]){
                    CarInfo[i].TepairItems = this.lossList2[i].project,
                    CarInfo[i].Content = this.lossList2[i].content;
                    CarInfo[i].Evaluation = this.lossList2[i].price;
                }
            };
            console.log(CarInfo);
            let option = {
                "CaseObject":"车辆",
                "ReportNo": this.detail.assets.caseNo,
                "CaseName": this.detail.assets.caseName+'损失评估报告',
                "EnProject":this.detail.assets.entrustedProject+'损失评估',
                "Client": this.detail.carDamage.clientName,
                "Number":this.detail.assets.caseNo,
                "DateTime": this.nowDate,
                "Preface": '\n\n'+this.detail.carDamage.introduction,
                "Statement": '\n\n'+this.detail.carDamage.statAppra,
                "Purpose": '\n\n'+this.detail.carDamage.evaluaPurpose,
                "BaseDate": '\n\n'+this.detail.carDamage.appraisalDate,
                "LossSet": '\n\n'+this.detail.carDamage.sshd,
                "EVObj": '\n\n'+this.detail.carDamage.pgdx,
                "Principle": '\n\n'+this.detail.carDamage.evaluationPrin,
                "Basis":'\n\n'+ this.detail.carDamage.bxzrdyj,
                "PriceBasis": '\n\n'+this.detail.carDamage.jgpgyj,
                "PriceMethod": '\n\n'+'成本法。',
                "AppraisalBasis": '\n\n'+this.detail.carDamage.ggyj,
                "LegalEffect": '\n\n'+this.detail.carDamage.pgbgflxl,
                "company": "广州天信保险公估有限公司",
                "DateInfo": this.zhDate,
                "DataInfo": [
                    {
                        "MoveToBookmark": "condition",
                        "Write": "资质资料",
                        "ImgBytes": this.assetsNalMap1
                    },
                    {
                        "MoveToBookmark": "Assessor",
                        "Write": "公估师",
                        "ImgBytes":this.assetsNalMap2
                    },        
                    // {
                    //     "MoveToBookmark": "CarBadInfo",
                    //     "Write": "车辆损失清单",
                    //     "ImgBytes": [
                    //         imgStr
                    //     ]
                    // },        
                    {
                        "MoveToBookmark": "EntrustBook",
                        "Write": "委托书",
                        "ImgBytes": this.assetsNalMap3
                    },        
                    {
                        "MoveToBookmark": "BillAndCard",
                        "Write": "相关证件、单据",
                        "ImgBytes": this.assetsNalMap4
                    },        
                    {
                        "MoveToBookmark": "CarBadImg",
                        "Write": "车辆损失相片",
                        "ImgBytes": this.assetsNalMap5
                    }
                ],
                "LoseExplain": '\n\n'+'1、配件价格我司经由线上系统、线下市场询价。'+'\r\n\n'+
                '2、本评估报告不包括施救费用定损,也未扣除残值。“施救费”指对车辆必要的、合理的施救费用支出,“残值”指车辆经维修更换下来的残余配件价值。'+'\r\n\n'+
                '3、本评估报告所列费用金额均已包含各项税费。'+'\r\n\n'+
                '4、本评估报告金额依据委托人提供损失情况进行评估，不包含隐性损失。'+'\r\n\n'+
                '5、本评估报告不包含车辆修复后贬值或升值。'+'\r\n\n'+
                '6、残值处理建议：建议旧件回收。',
                "TemplateNo":"CarBad",




                "LossList": {
                    "Name": "机动车辆损失明细单",
                    "TotalAmount":'总计金额：'+this.totalPrice+ '('+(parseInt(this.price1)+parseInt(this.price2)+'元')+")",
                    "Owner": [
                        {
                            "CarMaster": "车主",
                            "Name": this.detail.carDamage.owner,
                            "CarIDName": "车牌号",
                            "CarID": this.detail.carDamage.licenseNo,
                            "Brand": "厂牌型号",
                            "Model": this.detail.carDamage.brand
                        }
                    ],
                    "WIN": [
                        {
                            "Winkey": "VIN码",
                            "WinValue": this.detail.carDamage.vehicleNo,
                            "Engine": "发动机号",
                            "EngineNO": this.detail.carDamage.engineNo
                        }
                    ],
                    "CarInfo": CarInfo,
                    "Charging":[{
                        "Material":'材料费小计：'+JSON.stringify(this.price1)+'元',
                        "WorkingHours":'工时费小计: '+JSON.stringify(this.price2)+'元',
                    }]
                }
            };
            console.log(JSON.stringify(option))
            let res = await api.getPDFCarBad(option,this.detail.assets.caseName+'损失评估报告');
            console.log(res);
        },
       
        backTop(){
            document.querySelector('.el-main').scrollTop = 0
        },
        // biaotou(){
        //     document.querySelector('.el-main').scrollTop = 0
        //     let _this = this;
        //     html2Canvas(document.getElementById('top'),{
        //             backgroundColor: null, // 背景颜色
        //             dpi: 192, // 将分辨率提高到特定的dpi,默认值为96
        //             scale: 2, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
        //             useCORS:true, // 是否尝试使用CORS从服务器加载图像
        //             scrollY: 0, 
        //             scrollX: 0,
        //     }).then((canvas) => {
        //         _this.convertCanvasToImage(canvas);
        //     })
        // },
        convertCanvasToImage(canvas) {
            var imgStr = canvas.toDataURL("image/png");
            // var img=new Image();
            // img.src=imgStr;
            // console.log('imgStr');
            // console.log(imgStr);
            this.createPdf(imgStr);
            // document.querySelector('.dingmeiimg').append(img);
        },
        // createPage(){
        //     this.page=1;
        //     store.dispatch('global/setLoading', true);
        //     var canvas = document.getElementById('pdfdom');
        //     var a4Width = 595.28;
        //     var a4Height = 701.89;
        //     var a4HeightRef = Math.floor((canvas.offsetWidth / a4Width) * a4Height)
        //     var p = canvas.offsetHeight/a4HeightRef;
        //     var pages = document.querySelector('.pages');
        //     for(let i = 0;i < p+2;i++){
        //         pages.innerHTML = pages.innerHTML + '<div class="page page'+this.page+'" style="width: 880px;font-size: 14px;text-align: center;">第'+this.page+'页</div>';
        //         this.pageToCanvas('page'+this.page);
        //         this.page = this.page+1;
        //     }

        //     this.biaotou();
        // },
        // pageToCanvas(page){
        //     console.log(page);
        //     let _this = this;
        //     html2Canvas(document.querySelector('.'+page),{
        //             backgroundColor: null, // 背景颜色
        //             dpi: 192, // 将分辨率提高到特定的dpi,默认值为96
        //             scale: 1, // 用于渲染的比例尺。默认为浏览器设备像素比率。默认值是1，手机端设置成2
        //             useCORS:true, // 是否尝试使用CORS从服务器加载图像
        //             scrollY: 0, 
        //             scrollX: 0,
        //     }).then((canvas) => {
        //         _this.pageCanvasToImage(canvas,page);
        //     })
        // },
        // pageCanvasToImage(canvas, className){
        //     var imgStr = canvas.toDataURL("image/png");
        //     var img=new Image();
        //     img.src=imgStr;
        //     img.setAttribute('class', 'img'+className)
        //     document.querySelector('.pages').append(img);
        //     // this.getPdf('#pdfdom')
        // },
       
        async queryAssetsMaterialDamage(){
            let res = await api.QueryAssetsCarDamage(this.$route.query.id);
            console.log(res);
            this.detail = res.data.data;
            this.detail.assets.crimeCityCode = [this.detail.assets.crimeCityCode.split(',')[0],this.detail.assets.crimeCityCode.split(',')[1]];
            if(this.detail.assets.entrustDate){
                this.detail.assets.entrustDate = this.detail.assets.entrustDate.split(' ')[0];
            }
            // this.zhDate = this.CNDateString(new Date(this.detail.assets.entrustDate));
             this.nowDate = this.getDateYMD();
            this.zhDate = this.CNDateString(new Date(this.nowDate));
            for(let index in this.detail.assetsMaps){
                if(this.detail.assetsMaps[index].assetsMapsType==10){
                    this.assetsMaps1.push(this.detail.assetsMaps[index].path)
                }else{
                    this.assetsMaps2.push(this.detail.assetsMaps[index].path)
                }
            }
            for(let index in this.detail.assetsNalMap){
                if(this.detail.assetsNalMap[index].assetsNulMapType==10){
                    this.assetsNalMap1.push(this.detail.assetsNalMap[index].path)
                }else if(this.detail.assetsNalMap[index].assetsNulMapType==20){
                    this.assetsNalMap2.push(this.detail.assetsNalMap[index].path)
                }else if(this.detail.assetsNalMap[index].assetsNulMapType==30){
                    this.assetsNalMap3.push(this.detail.assetsNalMap[index].path)
                }else if(this.detail.assetsNalMap[index].assetsNulMapType==40){
                    this.assetsNalMap4.push(this.detail.assetsNalMap[index].path)
                }else if(this.detail.assetsNalMap[index].assetsNulMapType==100){
                    this.assetsNalMap5.push(this.detail.assetsNalMap[index].path)
                }
            }

            for(let index in this.detail.carLossList){
                if(this.detail.carLossList[index].carLossType==10){
                    this.lossList1.push(this.detail.carLossList[index]);
                    this.price1 = this.price1 + (this.detail.carLossList[index].price)
                }else{
                    this.lossList2.push(this.detail.carLossList[index]);
                    this.price2 = this.price2 + this.detail.carLossList[index].price
                }
            }
            if(this.lossList1.length > this.lossList2.length){
                for(let i=0;i< (this.lossList1.length-this.lossList2.length);i++){
                    this.zeroList2.push('');
                }
            }
            else if(this.lossList1.length < this.lossList2.length){
                for(let i=0;i< (this.lossList2.length-this.lossList1.length);i++){
                    this.zeroList1.push('');
                }
            }
            this.totalPrice = convertCurrency(this.price1+this.price2)
        },
        
        
        CNDateString(date){
            var cn = ["〇","一","二","三","四","五","六","七","八","九"];
            var s = [];
            var YY = date.getFullYear().toString();
            for (var i=0; i<YY.length; i++)
            if (cn[YY.charAt(i)])
            s.push(cn[YY.charAt(i)]);
            else
            s.push(YY.charAt(i));
            s.push("年");
            var MM = date.getMonth()+1;
            if (MM<10)
            s.push(cn[MM]);
            else if (MM<20)
            s.push("十" + cn[MM% 10]);
            s.push("月");
            var DD = date.getDate();
            if (DD<10)
            s.push(cn[DD]);
            else if (DD<20)
            s.push("十" + cn[DD% 10]);
            else if (DD<30)
            s.push("二十" + cn[DD% 10]);
            else
            s.push("三十" + cn[DD% 10]);
            s.push("日");
            return s.join('');
        }
        
    }
    
}
</script>

<style lang="scss" scoped>
   
    .carReport{
        // font-family: 'simsun';
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 20px;
        .backtop{
            box-shadow: 0 4px 4px rgba(0,21,41,.1);
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            right: 50px;
            bottom: 100px;
            font-size: 36px;
            background-color: rgba(0, 0, 0, 0.2);
            color: #ffffff;
            cursor: pointer;
        }
        .tops{
            padding: 0 100px;
            // .biaotou{
            //     width: 880px;
            // }
        }
        .top{
            width: 680px;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #000000;
            .l{
                display: flex;
                flex-direction: column;
                .l-t{
                    font-size: 22px;
                }
                .l-b{
                    font-size: 12px;
                    margin-top: 4px;
                }
            }
            .r{
                font-size: 22px;
                span{
                    color: red;
                    font-size: 14px;
                    text-decoration: underline;
                }
            }
        }
        .pdf{
            // border: 1px solid #000000;
            width: 880px;
            .pdf-content1{
                width: 680px;
                padding: 100px;
                padding-bottom: 0;
            }
            .imgs{
                width: 680px;
                padding: 0 100px;
            }
            .title{
                font-size: 56px;
                margin-top: 100px;
                font-weight: bold;
                text-align: center;
            }
            .name{
                font-size: 36px;
                text-align: center;
                margin-top: 100px;
                font-weight: bold;
            }
            .info{
                width: 400px;
                margin: 0 auto;
                margin-top: 100px;
                font-weight: bold;
                .item{
                    font-size: 20px;
                    display: flex;
                    line-height: 40px;
                    .label{
                        width: 100px;
                    }
                    .value{
                        width: 300px;
                        text-decoration: underline;
                    }
                }
            }
            .name2{
                font-size: 36px;
                text-align: center;
                margin-top: 400px;
                font-weight: bold;

            }
            .tip{
                font-size: 26px;
                margin-top: 100px;
                font-weight: bold;
            }
            .name3{
                font-size: 20px;
                text-decoration: underline;
                text-align: center;
                margin-top: 30px;
                font-weight: bold;
                margin-bottom: 50px;
            }
            .content{
                .item{
                    line-height: 50px;
                    .item-t{
                        font-size: 20px;
                        font-weight: bold;
                    }
                    .item-c{
                        text-indent:2em;
                        font-size: 18px;
                    }
                }
            }
            .signature{
                margin-top: 40px;
                .item{
                    line-height: 40px;
                    font-size: 18px;
                    font-weight: bold;
                }
            }
            .company{
                display: flex;
                flex-direction: column;
                .item{
                    font-size: 18px;
                    display: flex;
                    flex-direction: row-reverse;
                    font-weight: bold;
                    line-height: 40px;
                }
            }
            .imgs{
                padding-top: 100px;

                .table{
                    margin-top: 20px;
                    width: 100%;
                    border-top: 2px solid #000000;
                    border-left: 2px solid #000000;
                    box-sizing: border-box;
                    font-weight: bold;
                    .header{
                        border-bottom: 2px solid #000000;
                        border-right: 2px solid #000000;
                        box-sizing: border-box;
                        img{
                            width: 100%;
                        }
                    }
                    .t-title{
                        border-bottom: 2px solid #000000;
                        border-right: 2px solid #000000;
                        font-weight: bold;
                        text-align: center;
                        height: 30px;
                        line-height: 30px;
                        box-sizing: border-box;

                    }
                    .contentall{
                        display: flex;
                        .content1{
                            flex: 5;
                            box-sizing: border-box;
                            border-right: 2px solid #000000;
                        }
                        .content2{
                            flex: 4;
                            box-sizing: border-box;
                            border-right: 2px solid #000000;
                        }
                    }
                    .tr{
                        width: 100%;
                        display: flex;
                        font-size: 14px;
                        min-height: 40px;
                        .td1{
                            flex: 1;
                            box-sizing: border-box;
                            border-bottom: 2px solid #000000;
                            border-right: 2px solid #000000;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            text-align: center;

                        }
                        .td2{
                            flex: 2;
                            border-bottom: 2px solid #000000;
                            border-right: 2px solid #000000;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            text-align: center;
                            box-sizing: border-box;
                        }
                        .td3{
                            flex: 3;
                            border-bottom: 2px solid #000000;
                            border-right: 2px solid #000000;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            text-align: center;
                            box-sizing: border-box;
                        }
                        .td4{
                            flex: 4;
                            border-bottom: 2px solid #000000;
                            border-right: 2px solid #000000;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            text-align: center;
                            box-sizing: border-box;
                        }
                        .td5{
                            flex: 5;
                            border-bottom: 2px solid #000000;
                            border-right: 2px solid #000000;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            text-align: center;
                            box-sizing: border-box;
                        }
                        .td9{
                            flex: 9;
                            border-bottom: 2px solid #000000;
                            border-right: 2px solid #000000;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            text-align: center;
                            box-sizing: border-box;
                        }
                        .td7{
                            flex: 7;
                            border-bottom: 2px solid #000000;
                            border-right: 2px solid #000000;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            text-align: center;
                            box-sizing: border-box;
                        }
                        .td8{
                            flex: 8;
                            border-bottom: 2px solid #000000;
                            border-right: 2px solid #000000;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            text-align: center;
                            box-sizing: border-box;
                        }
                        .td1noborder{
                            border-right: 0;
                        }
                        .tdzero{
                            border:0;
                        }
                    }
                }

                .img{
                    .img-t{
                        font-size: 20px;
                        margin-top: 100px;
                    }
                    .imglist{
                        width: 100%;
                        margin-top: 20px;
                        display: flex;
                        flex-wrap: wrap;
                        .imgitem{
                            .image{
                                max-width: 680px;
                                margin-bottom: 2px;
                            }
                        }
                    }
                    .imglist2{
                        .imgitem{
                            .image{
                                width: 225px;
                                height: 225px;
                                margin-left: 1px;
                                margin-bottom: 1px;
                            }
                        }
                    }
                    
                }
            }
            
        }
        
    }
    .pages{
        width: 880px;
        .page{
            width: 880px;font-size: 14px;text-align: center;
            display: flex;
            justify-content: center;
        }
    }
</style>
